export const GenderType = { WOMAN: 'Woman', MAN: 'Man', PREFERNOTSAY: 'Prefer not to say' };
